module.exports = __webpack_public_path__ + "img/banner.8378cfc8.png";